import type { ReactNode } from 'react';
import { Icon, type IconName } from './icons';

/**
 * حالة فارغة: ما الذى لا يوجد، ولماذا يهم، وما الخطوة التالية — بدل سطر رمادى
 * «لا شىء بعد» لا يخبر صاحب الشركة ماذا يفعل.
 */
export default function EmptyState({
  icon = 'empty',
  title,
  children,
  action,
}: {
  icon?: IconName;
  title: string;
  children?: ReactNode;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="empty-state">
      <span className="empty-art" aria-hidden="true">
        <Icon name={icon} size={30} />
      </span>
      <strong>{title}</strong>
      {children && <p>{children}</p>}
      {action && (
        <button type="button" className="ghost empty-action" onClick={action.onClick}>
          <Icon name="plus" size={18} />
          {action.label}
        </button>
      )}
    </div>
  );
}
